import React from "react";
import { useTheme } from "@material-ui/core/styles";
import {
	BarChart,
	CartesianGrid,
	Bar,
	XAxis,
	YAxis,
	Label,
	Tooltip,
	ResponsiveContainer,
} from "recharts";

import Title from "./Title";

const Chart = ({ serie, titulo, loading }) => {
	const theme = useTheme();

	const pontos = serie?.pontos || [];
	const total = pontos.reduce((soma, p) => soma + (p.total || 0), 0);

	
	const intervaloEixo = pontos.length > 16 ? "preserveStartEnd" : 0;

	return (
		<React.Fragment>
			<Title>{`${titulo || "Atendimentos"}: ${loading ? "…" : total}`}</Title>
			{}
			<div style={{ flex: 1, minHeight: 0 }}>
				<ResponsiveContainer width="100%" height="100%">
					<BarChart
						data={pontos}
						maxBarSize={28}
						margin={{
							top: 16,
							right: 16,
							bottom: 0,
							left: 8,
						}}
					>
						<CartesianGrid strokeDasharray="3 3" />
						<XAxis
							dataKey="label"
							interval={intervaloEixo}
							minTickGap={8}
							tick={{ fontSize: 11 }}
							stroke={theme.palette.text.secondary}
						/>
						<YAxis
							type="number"
							width={34}
							allowDecimals={false}
							tick={{ fontSize: 11 }}
							stroke={theme.palette.text.secondary}
						>
							<Label
								angle={270}
								position="insideLeft"
								offset={-2}
								style={{
									textAnchor: "middle",
									fontSize: 11,
									fill: theme.palette.text.secondary,
								}}
							>
								Atendimentos
							</Label>
						</YAxis>
						<Tooltip
							cursor={{ fill: "rgba(13,148,136,0.08)" }}
							formatter={value => [value, "Atendimentos"]}
						/>
						<Bar
							dataKey="total"
							radius={[4, 4, 0, 0]}
							fill={theme.palette.primary.main}
						/>
					</BarChart>
				</ResponsiveContainer>
			</div>
		</React.Fragment>
	);
};

export default Chart;
